import types from 'redux/types';
import _ from 'lodash';
import Queue from 'helpers/queue';
import { checkTypeValue } from 'helpers';

const {
  REQUEST_API_AUTO_REPLIES_SERVLET,
  REQUEST_API_AUTO_REPLIES_SERVLET_SUCCESS,
  REQUEST_API_AUTO_REPLIES_SERVLET_FAILED,
  REQUEST_CLEAR_AUTO_REPLIES_SERVLET_SUCCESS,
  REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS,
  REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_SUCCESS,
  REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_FAILED,
} = types;

const queueRequest = new Queue();
const initialState = {
  isFetching: true,
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  switch (actions.type) {
    case REQUEST_API_AUTO_REPLIES_SERVLET:
      return {
        ...state,
        isFetching: true,
      };

    case REQUEST_API_AUTO_REPLIES_SERVLET_SUCCESS:
      return {
        ...state,
        data: actions.data,
        isFetching: false,
      };

    case REQUEST_API_AUTO_REPLIES_SERVLET_FAILED:
      return {
        ...state,
        error: actions.error,
        isFetching: false,
      };

    case REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS: {
      const { groupId } = actions;
      queueRequest.pushToQueue(typeof groupId === 'string' ? Number(groupId) : groupId);
      return {
        ...state,
        queue: _.uniq(queueRequest.queue),
      };
    }

    case REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_SUCCESS: {
      const { groupId, status } = actions;
      let data = state.data || [];
      const indexElement = data.findIndex((el) => el.id === groupId);
      data[indexElement]['isActive'] = status;
      queueRequest.removeFromQueue(groupId);
      return {
        ...state,
        queue: queueRequest.queue,
        data,
      };
    }

    case REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_FAILED: {
      const { groupId } = actions;
      queueRequest.removeFromQueue(groupId);
      return {
        ...state,
        error: actions.error,
        queue: queueRequest.queue,
      };
    }

    case REQUEST_CLEAR_AUTO_REPLIES_SERVLET_SUCCESS: {
      return {
        isFetching: true,
      };
    }

    default:
      return state;
  }
};
